import { configureStore } from "@reduxjs/toolkit";

const store = configureStore({
	reducer: {
		// language: languageSlice,
	},
});

export default store;
